import * as yup from 'yup';
import Schema from '@/schema/Schema';
import { I18n } from 'aws-amplify';
const UpdateCorporationDetailSchema = Schema.object().shape({
    corporationName: yup
        .string()
        .required(I18n.get('COMMSG014'))
        .max(500, I18n.get('COMMSG022').replace('{{maxLength}}', '500'))
        .trim(),
});

export default UpdateCorporationDetailSchema;
